/**
 * `W4-T17` §6 — why an undo was refused, as a key.
 *
 * The browser only ever sees a refusal's **code** (`ApiError.message`, `shared/api.ts` `call`), never
 * its reason. A payment in progress has its own code, `QUOTE_PAYMENT_PENDING`, because nothing on the
 * job page shows a booking and no re-read could tell it apart (E3 = B). The two `CONFLICT`s are
 * terminal states the page does show, and the action has re-read the job before this runs: a job
 * that is no longer `OPEN` is the server's first check, so it is the answer; otherwise the quote left
 * `ACCEPTED`.
 */
import { type JobStatus } from '@marketplace/contracts';

export type UnacceptErrorKey =
  | 'job.quotes.unaccept.paymentPending'
  | 'job.quotes.unaccept.jobClosed'
  | 'job.quotes.unaccept.notAccepted'
  | 'job.quotes.unaccept.notFound'
  | 'job.quotes.error';

export function unacceptErrorKey(code: string, jobStatus: JobStatus): UnacceptErrorKey {
  switch (code) {
    case 'QUOTE_PAYMENT_PENDING':
      return 'job.quotes.unaccept.paymentPending';
    case 'CONFLICT':
      return jobStatus === 'OPEN'
        ? 'job.quotes.unaccept.notAccepted'
        : 'job.quotes.unaccept.jobClosed';
    case 'NOT_FOUND':
      return 'job.quotes.unaccept.notFound';
    default:
      return 'job.quotes.error';
  }
}
